import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus'
import type { ILearningModuleUrlOptions } from '@/core/domain/learning/module/ILearningModuleUrlOptions.ts'

export class LearningModuleUrlOptions implements ILearningModuleUrlOptions {
  withGrains?: boolean
  withSupports?: boolean
  withTask?: boolean
  status?: LearningStatus.Values[]

  constructor(obj: ILearningModuleUrlOptions) {
    // Handle hierarchical dependencies
    this.withTask = obj.withTask // Independent from other parameters

    // If withGrains is true, withModules must also be true
    // If withSupports is true, both withGrains and withModules must be true
    this.withSupports = obj.withSupports
    this.withGrains = obj.withGrains || this.withSupports

    this.status = obj.status
  }

  getUrlOptions(): string {
    // Handle special case when everything is false except withTask or status
    const onlyTaskOrStatus =
      !this.withGrains &&
      !this.withSupports &&
      (this.withTask || (this.status && this.status.length > 0))

    if (onlyTaskOrStatus) this.withSupports = this.withGrains = false

    // Build URL based on dependencies
    const params = new URLSearchParams()

    // withTask is always added because it's independent
    params.append('withTask', String(!!this.withTask))

    // Other parameters are added according to dependency rules
    params.append('withGrains', String(!!this.withGrains))

    // Only add withSupports if withGrains is true

    params.append('withSupports', String(!!this.withSupports))

    // Always add status if it exists
    if (this.status && this.status.length > 0) {
      params.append('status', this.status.join(','))
    }

    return `?${params.toString()}`
  }

  // Utility method to normalize options according to dependency rules
  static normalizeOptions(options: ILearningModuleUrlOptions): ILearningModuleUrlOptions {
    const normalized = { ...options }

    // Apply dependency rules
    if (normalized.withSupports) {
      normalized.withGrains = true
    }

    return normalized
  }
}
